import fetch from "api/utils/enhancedFetch";
import { getProxycadorHost } from "environment";
import { VipConfig } from "state/flows/loadVipConfigs";

export const fetchVipConfigs = (): Promise<VipConfig[]> =>
  fetch(`${getProxycadorHost()}/proxycador/api/public/v1/vip/configs`).then(
    (resp) => resp.json()
  );
